import { LoaderFunction, redirect } from "react-router-dom";

import { getSession } from "@/client/utils/get-session";

export const authLoader: LoaderFunction = async () => {
  try {
    const session = await getSession();

    if (!session) {
      return redirect("https://student.hi-interns.com/api/redirect/hi-resume");
    }

    return null;
  } catch (error) {
    console.error(error);
    return redirect("https://student.hi-interns.com/api/redirect/hi-resume");
  }
};
